import { useMemo } from "react";
import config from "@Config/index";
import useWhitelabel from "hooks/useWhitelabel";
import { SERVICE_TABS } from "@Pages/AmberPlusCross/constants/amberPlusForexConstants";
import { ServiceTab } from "@Pages/AmberPlusCross/constants/types";

// Tabs hidden from the service rail on the global (amberstudent.com) build only.
// China and whitelabel keep the full SERVICE_TABS list. The bank route/slug and
// its content stay intact — only the rail entry is removed, so direct links and
// FocusedDefault's label lookup (which reads SERVICE_TABS) are unaffected.
const GLOBAL_HIDDEN_TABS: ServiceTab[] = ["bank"];

const NO_HIDDEN_TABS: ServiceTab[] = [];

/**
 * Service ids hidden on the current build — `["bank"]` on global, empty on China and
 * whitelabel. Shared by the plus-cross rail and the home/booking/payment touchpoints
 * strip so the same services disappear from every entry point together.
 */
export const useHiddenServiceTabs = (): ServiceTab[] => {
  const { isWhitelabel } = useWhitelabel();
  const isGlobal = !config.IS_CHINA_APP && !config.IS_WHITELABEL_APP && !isWhitelabel;

  return isGlobal ? GLOBAL_HIDDEN_TABS : NO_HIDDEN_TABS;
};

const useServiceTabs = () => {
  const hidden = useHiddenServiceTabs();

  return useMemo(() => SERVICE_TABS.filter((tab) => !hidden.includes(tab.id)), [hidden]);
};

export default useServiceTabs;
